import React from 'react';
import { Modal } from 'react-bootstrap';
import { Row, Col, Spinner } from 'reactstrap';
import './spinner.scss';
export const SpinnerDni = () => {
  return (
    <Modal.Body className="modal-spinner-dni">
      <Row className="d-flex text-center justify-content-center align-items-center container-spinner mt-5">
        <Col>
          <Spinner size="xl" className="spinner-dni"></Spinner>
        </Col>
      </Row>
    </Modal.Body>
  );
};